import type { InterestTagEntry } from './signalDictionary'

// STORYBOOK FIXTURE — not production data. A small, representative slice of
// interest GiftTags so the concierge demo and specs have something to match. In
// production the island swaps in the live GiftTag corpus it is served
// (Home::BuyersConcierge → setInterestVocabulary) — this list is NOT that, and is
// deliberately tiny. Do not grow it toward a full corpus.
export const INTEREST_TAGS: InterestTagEntry[] = [
  { name: 'food', variants: ['foodie', 'cooking', 'culinary'] },
  { name: 'sushi', variants: [] },
  { name: 'tacos', variants: [] },
  { name: 'pizza', variants: [] },
  { name: 'coffee', variants: ['coffee lover', 'caffeine'] },
  { name: 'matcha', variants: [] },
  { name: 'tea', variants: [] },
  { name: 'beer', variants: [] },
  { name: 'wine', variants: ['wine lover'] },
  { name: 'baking', variants: [] },
  { name: 'candles', variants: [] },
  { name: 'travel', variants: ['adventure', 'jetsetter'] },
  { name: 'outdoors', variants: ['hiking', 'camping', 'nature'] },
  { name: 'fishing', variants: [] },
  { name: 'golf', variants: [] },
  { name: 'running', variants: [] },
  { name: 'yoga', variants: [] },
  { name: 'fitness', variants: ['gym', 'working out'] },
  { name: 'soccer', variants: [] },
  { name: 'gaming', variants: ['gamer', 'video games'] },
  { name: 'music', variants: ['music lover', 'concert'] },
  { name: 'jazz', variants: [] },
  { name: 'movies', variants: ['film', 'cinema'] },
  { name: 'books', variants: ['reading', 'bookworm'] },
  { name: 'art', variants: ['crafts', 'creative'] },
  { name: 'fashion', variants: ['style'] },
  { name: 'beauty', variants: ['makeup', 'skincare'] },
  { name: 'gardening', variants: ['plants'] },
]
